var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isValidBrowser)?[_c('v-main',[_c('v-scroll-y-reverse-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('sb-snackbar')]:_c('sb-browser-warning')],2)}
var staticRenderFns = []

export { render, staticRenderFns }